let storeService = "zrs";
let envService = "sandbox";
let origin = window.location.origin;
if (origin === "https://www.zymoresearch.com") {
  storeService = "zrc";
  envService = "production";
} else if (origin === "https://www.zymoresearch.de") {
  storeService = "zre";
  envService = "production";
} else if (origin === "https://zymoresearch.eu") {
  storeService = "zeu";
  envService = "production";
}


function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let [key,value] = el.split('=');
    cookie[key.trim()] = value;
  })
  return cookie[cookieName];
}

function assignClickTrackObjectService() {
  let clickTrackDirect = localStorage.getItem("clickTrackGCLIDDirect");
  let clickTrackAssisted = localStorage.getItem("clickTrackGCLIDAssisted");

    // run getClickTrackObject() from site-theme.js file
    const clickTrackObject = getClickTrackObject();

    if (clickTrackDirect) {
      clickTrackObject.type = "direct"
    } else if (clickTrackAssisted) {
      clickTrackObject.type = "assisted"
    } 

    clickTrackObject.store = storeService || "not found";
    clickTrackObject.env = envService;
    clickTrackObject.gat_origin = `service_inquiry_{{page.handle}}`;

    let gclidInput = document.getElementById("gclid");
    let gclidInputGeneral = document.getElementById("gclid-general")
    let gclidInputNucleic = document.getElementById("gclid-nucleic");

    if (gclidInput) {
      gclidInput.value = JSON.stringify(clickTrackObject);
    } else if (gclidInputGeneral) {
      gclidInputGeneral.value = JSON.stringify(clickTrackObject);
      gclidInputNucleic.value = JSON.stringify(clickTrackObject);
    }
}

assignClickTrackObjectService();